<div class="notification-banner" [ngClass]="type">
    <ng-content select="[icon]"></ng-content>
    <div class="message">
        <ng-content select="[message]"></ng-content>
    </div>
</div>
